if (!customElements.get('m2-editorial-slideshow')) {
  customElements.define('m2-editorial-slideshow', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort(); this.abort = new AbortController();
      const on = (target, event, callback, options = {}) => target.addEventListener(event, callback, {...options, signal: this.abort.signal});
      this.track = this.querySelector('.m2-editorial__track');
      this.slides = [...this.querySelectorAll('.m2-editorial__slide')];
      this.dots = [...this.querySelectorAll('[data-slide]')];
      if (!this.track || !this.slides.length) return;
      this.index = 0; this.manualPause = false; this.inViewport = true; this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.playButton = this.querySelector('[data-play]');
      this.querySelector('.m2-editorial__controls')?.removeAttribute('hidden');
      on(this,'click',event=>{
        const button=event.target.closest('button'); if(!button)return;
        if(button.hasAttribute('data-prev'))this.move(this.index-1,true);
        if(button.hasAttribute('data-next'))this.move(this.index+1,true);
        if(button.hasAttribute('data-slide'))this.move(Number(button.dataset.slide),true);
        if(button.hasAttribute('data-play')){this.manualPause=!this.manualPause;this.syncTimer();}
      });
      on(this.track,'keydown',event=>{
        let next; if(event.key==='ArrowRight')next=this.index+1;
        if(event.key==='ArrowLeft')next=this.index-1;
        if(event.key==='Home')next=0;if(event.key==='End')next=this.slides.length-1;
        if(next!==undefined){event.preventDefault();this.move(next,true);}
      });
      on(this.track,'scroll',()=>{clearTimeout(this.scrollTimer);this.scrollTimer=setTimeout(()=>this.update(Math.round(this.track.scrollLeft / this.track.clientWidth)),90);},{passive:true});
      on(this,'pointerenter',()=>{this.hovered=true;this.syncTimer()});
      on(this,'pointerleave',()=>{this.hovered=false;this.syncTimer()});
      on(this,'focusin',()=>{this.focused=true;this.syncTimer()});
      on(this,'focusout',()=>{queueMicrotask(()=>{this.focused=this.contains(document.activeElement);this.syncTimer()})});
      on(this.track,'touchstart',()=>{this.manualPause=true;this.syncTimer()},{passive:true});
      on(document,'visibilitychange',()=>this.syncTimer());
      on(this.reduced,'change',()=>this.syncTimer());
      on(document,'shopify:block:select',event=>{if(this.contains(event.target)){const i=this.slides.findIndex(s=>s.dataset.blockId===event.detail?.blockId||s.contains(event.target));if(i>=0){this.manualPause=true;this.move(i,true,true)}}});
      this.observer?.disconnect();
      this.observer = new IntersectionObserver(entries=>{this.inViewport=entries[0].isIntersecting;this.syncTimer()},{threshold:0.15});
      this.observer.observe(this);
      on(window,'resize',()=>{this.track.scrollTo({left:this.index*this.track.clientWidth,behavior:'instant'})});
      this.update(0);this.syncTimer();
    }
    move(index,user=false){
      const next=(index+this.slides.length)%this.slides.length;
      if(user){this.manualPause=true;this.syncTimer();}
      clearTimeout(this.scrollTimer);
      this.update(next,user);
      this.track.scrollTo({left:next*this.track.clientWidth,behavior:!user&&!this.reduced.matches?'smooth':'auto'});
    }
    update(index,announce=false){
      this.index=Math.max(0,Math.min(index,this.slides.length-1));
      this.slides.forEach((slide,i)=>{const active=i===this.index;slide.setAttribute('aria-hidden',String(!active));slide.inert=!active;});
      this.dots.forEach((dot,i)=>{if(i===this.index)dot.setAttribute('aria-current','true');else dot.removeAttribute('aria-current')});
      if(announce){const status=this.querySelector('[data-slide-status]');if(status)status.textContent=this.slides[this.index].getAttribute('aria-label')}
    }
    syncTimer(){
      clearInterval(this.timer);
      const canPlay=this.dataset.autoplay==='true'&&!this.reduced.matches&&!this.manualPause&&!this.hovered&&!this.focused&&!document.hidden&&this.inViewport&&!window.Shopify?.designMode&&this.slides.length>1;
      if(canPlay)this.timer=setInterval(()=>this.move(this.index+1),Number(this.dataset.interval)||7000);
      if(this.playButton){const paused=this.manualPause||this.reduced.matches;const label=paused?this.playButton.dataset.playLabel:this.playButton.dataset.pauseLabel;this.playButton.querySelector('[data-pause-icon]').hidden=paused;this.playButton.querySelector('[data-play-icon]').hidden=!paused;this.playButton.setAttribute('aria-label',label);this.playButton.disabled=this.reduced.matches;}
    }
    disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();clearInterval(this.timer);clearTimeout(this.scrollTimer);}
  });
}
